<template>
  <div>
    <el-select v-model="value" @change="change" placeholder="请选择图层" clearable>
      <el-option
        v-for="(item, index) in layers"
        :label="item"
        :value="item"
        :key="index">
      </el-option>
    </el-select>
    <el-tabs v-model="activeName">
      <el-tab-pane name="echart">
        <div slot="label">
          <img src="@/assets/img/measure/icon_bar.png" width="12" height="14">
        </div>
        <div class="chart" ref="chart" :style="{ height: height + 'px' }"></div>
      </el-tab-pane>
      <el-tab-pane name="table">
        <div slot="label">
          <img src="@/assets/img/measure/icon_table.png" width="15" height="16">
        </div>
        <el-table
          :data="assetsList"
          :header-cell-style="{ 'background-color': '#F5F5F5', 'color': '#000000', 'font-size': 400, }"
          :cell-style="{ 'color': '#000000' }"
          @row-click = "rowClick"
          :row-class-name="tableRowClassName"
          border>
          <el-table-column
            prop="blockName"
            show-overflow-tooltip
            label="名称">
          </el-table-column>
          <el-table-column
            prop="objNum"
            show-overflow-tooltip
            label="数量">
          </el-table-column>
    </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  data () {
    return {
      assetsList: [],
      value: '',
      activeName: 'echart',
      height: 400,
      layers: [],
      currentIndex: -1
    }
  },
  computed: {
    cadId () {
      return this.$route.query.cadId || ''
    },
    cadVersion () {
      return this.$store.state.cadVersion || ''
    }
  },
  watch: {
    cadVersion () {
      this.value = ''
      this.currentIndex = -1
      this.getLayers()
      this.loadData()
    }
  },
  created () {
    this.getLayers()
    this.loadData()
  },
  destroyed () {
    this._chart.getZr().off('click')
    this._chart && this._chart.dispose()
  },
  methods: {
    getLayers () {
      this.$axios.get(this.$apis.measure.selectYhCadResourcesLayerByList, {
        cadId: this.cadId,
        cadVersion: this.cadVersion
      }).then(res => {
        this.layers = res || []
      })
    },
    loadEntityIds (blockName) {
      if (blockName) {
        this.$axios.get(this.$apis.measure.selectYhCadResourcesNameByList, {
          cadId: this.cadId,
          layerName: this.value,
          blockName: blockName,
          cadVersion: this.cadVersion
        }).then(res => {
          // this.$event.$emit('setAssetsActive', row.blockName)
          console.log('LoadEntity', res)
          this.$event.$emit('setAssetsActive', res.map(item => {
            return item.objectId
          }))
        })
      } else {
        this.$event.$emit('setAssetsActive', '')
      }
    },
    loadData () {
      this.$axios.get(this.$apis.measure.selectYhCadResourcesByList, {
        cadId: this.cadId,
        cadVersion: this.cadVersion,
        layerName: this.value
      }).then(res => {
        this.assetsList = res || []
        this.height = this.assetsList.length * 35
        const xData = this.assetsList.map(item => item.objNum)
        const yData = this.assetsList.map(item => item.blockName)
        this.$nextTick(() => {
          this.initEchart(xData, yData)
        })
      })
    },
    initEchart (xData, yData) {
      this._chart && this._chart.clear()
      this._chart = echarts.init(this.$refs.chart)
      const option = {
        grid: {
          left: 0,
          right: 10,
          bottom: 10,
          top: 10,
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#E3E3E3',
              type: 'line'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            //  改变x轴字体颜色和大小
            show: true,
            textStyle: {
              fontSize: 12,
              color: '#585858'
            }
          }
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            axisLabel: {
              show: true,
              formatter: (params) => {
                const str = params.length > 4 ? `${params.substring(0, 4)}...` : params
                return str
              },
              textStyle: {
                fontSize: 12,
                color: '#000000'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: yData
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            zlevel: 1,
            itemStyle: {
              normal: {
                borderRadius: [0, 4, 4, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: '#61A2FF'
                  },
                  {
                    offset: 1,
                    color: '#0069FF'
                  }
                ])
              }
            },
            barCategoryGap: 20,
            barWidth: 15,
            data: xData
          }
        ],
        dataZoom: yData.length > 23
          ? [{
              show: true,
              id: 'dataZoomY',
              type: 'slider',
              yAxisIndex: [0],
              filterMode: 'empty',
              borderColor: 'transparent',
              backgroundColor: '#D9D9D9',
              fillerColor: '#2275D3',
              handleStyle: {
                opacity: 0
              },
              right: 0,
              width: 5,
              startValue: 0,
              endValue: 23,
              showDetail: false,
              showDataShadow: false,
              brushSelect: false,
              zoomLock: false
            }, {
              type: 'inside',
              yAxisIndex: [0],
              zoomOnMouseWheel: false,
              moveOnMouseMove: true
            }]
          : []
      }
      if (yData.length === 0) {
        const img = require('@/assets/icon/empty.svg')
        this._chart.setOption({
          graphic: {
            elements: [{
              type: 'image',
              style: {
                image: img,
                width: 128,
                height: 117
              },
              left: 'center',
              top: 'center'
            }]
          }
        })
      } else {
        this._chart.setOption(option)
      }
      // 添加对图表渲染完成的监听
      this._chart.resize()
      this._chart.getZr().off('click')
      this._chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (this._chart.containPixel('grid', pointInPixel)) {
          const xIndex = this._chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1]
          if (this.currentIndex !== xIndex) {
            this.currentIndex = xIndex
          } else {
            this.currentIndex = -1
          }
          // this.$event.$emit('setAssetsActive', yData[this.currentIndex])
          this.loadEntityIds(yData[this.currentIndex])
          this.$event.$emit('setAssetsActive', yData[this.currentIndex])
          this.setChartActive()
        }
      })
    },
    setChartActive () {
      const seriesOption = this._chart.getOption().series[0]
      const { data } = seriesOption
      data.forEach((item, index) => {
        if (index === this.currentIndex) {
          data[index] = {
            value: item,
            itemStyle: {
              color: '#ff0000'
            }
          }
        } else {
          data[index] = item.value ? item.value : item
        }
      })
      seriesOption.data = data
      this._chart.setOption({
        series: [seriesOption]
      })
    },
    change () {
      this.currentIndex = -1
      this.loadData()
    },
    rowClick (row) {
      const index = this.assetsList.findIndex(item => item.blockName === row.blockName)
      if (this.currentIndex !== index) {
        this.currentIndex = index
        // this.$event.$emit('setAssetsActive', row.blockName)
        this.loadEntityIds(row.blockName)
      } else {
        this.currentIndex = -1
        this.$event.$emit('setAssetsActive', '')
      }
      this.setChartActive()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === this.currentIndex) {
        return 'active'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-select{
    width: 100%;
    border-radius: 4px;
    input{
      background: #F7F7F7;
    }
  }
  .el-tabs__nav{
    float: right;
  }
  .el-tabs__nav-wrap::after,.el-tabs__active-bar{
    display: none;
  }
  .el-tabs__nav{
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .el-tabs__item{
    padding: 0;
    width: 21px;
    height: 21px;
    div{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .is-active{
    background: linear-gradient(0deg, #ECECEC 0%, #E7F0FD 100%);
    border-radius: 4px;
    border: 1px solid #ECECEC;
  }
  .el-table__body-wrapper{
    width: 100%;
    min-height: 400px;
    max-height: calc(100vh - 233px);
    overflow-y: auto;
    cursor: pointer;
  }
  .active{
    background-color: #61A2FF;
  }
}

.chart{
  width: 100%;
  min-height: 400px;
  max-height: calc(100vh - 200px);
}
</style>
